/* src/app/payroll/item/payroll-item/payroll-item.component.scss */
body#themeTag :host .scroll-container {
  overflow: auto;
}
body#themeTag :host ::ng-deep {
  height: 95vh;
}
body#themeTag :host ::ng-deep i {
  width: 1rem;
  height: 1rem;
  font-size: 1rem !important;
}
body#themeTag :host ::ng-deep .clearable-date-filter {
  width: unset;
  padding: 0 0.5rem;
  height: 1.5rem;
}
body#themeTag :host ::ng-deep .p-datatable-scrollable-header {
  margin-bottom: -0.75em;
}
body#themeTag :host ::ng-deep #employees .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header,
body#themeTag :host ::ng-deep #employees .p-datatable .p-datatable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header {
  height: 3em;
}
/*# sourceMappingURL=payroll-item.component.css.map */
